<ng-container *transloco="let formlyFileUploaderTranslation; read: 'formly-file-uploader'">
    <ng-container *transloco="let fieldTranslation; read: 'field-types'">
        <div *ngIf="loading$ | async" class="inset-x-0 top-0">
            <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
        </div>
        <div class="flex flex-col gap-4">
            <div class="flex flex-col gap-4" *ngIf="datasource && datasource.length > 0">
                <div class="flex items-center justify-between bg-card px-4 py-1 rounded border border-border"
                    *ngFor="let item of datasource">
                    <span class="text-bold" *ngFor="let objectProperties of item | keyvalue">
                        {{ objectProperties.key }}
                    </span>
                    <button mat-icon-button (click)="removeItem(item)">
                        <mat-icon [svgIcon]="'trash'"></mat-icon>
                    </button>

                </div>
            </div>
            <ngx-file-drop class="w-full" (onFileDrop)="dropped($event)" [multiple]="true"
                [accept]="fileTypes?.join(',')" [directory]="false" dropZoneClassName="" [disabled]="isDisabled()"
                *ngIf="!(datasource.length >= maxNumberOfFiles)">
                <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                    <div class="h-full w-full rounded-2xl border border-dashed flex p-4 justify-center tinted ">
                        <div class="flex flex-col gap-2 items-center place-content-center">
                            <div class="flex gap-4 items-center">
                                <span class="text-black">
                                    Arraste para cá ou
                                </span>
                                <v2-button-wrapper color="accent" [text]="'Busque por arquivos'" icon="arrow-right"
                                    variant="stroked" [disabled]="isDisabled()"
                                    (click)="openFileSelector()"></v2-button-wrapper>
                            </div>
                            <mat-hint class="text-hint text-xs">{{ 'Tamanho máximo por arquivo: 50 MB'
                                }}</mat-hint>
                        </div>
                    </div>
                </ng-template>
            </ngx-file-drop>
        </div>
    </ng-container>
</ng-container>